import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { StepStatus } from '~/enums';
import { pushToGtmLoanAction } from '~/store/actions/gtmActions';
import { goToNextStep } from '~/store/slices/loanOffer.slice';
import { RootState } from '~/store';

const useGoToNextStep = () => {
  const dispatch = useAppDispatch();
  const { currentStep } = useSelector((state: RootState) => state.loanOffer);

  const onNextStepClick = useCallback(() => {
    dispatch(pushToGtmLoanAction({ actionName: 'next_button_pressed' }));
    dispatch(pushToGtmLoanAction({ stepStatus: StepStatus.Finished }));
    dispatch(goToNextStep());
  }, [dispatch, currentStep]);

  return onNextStepClick;
};

export default useGoToNextStep;
